import React, { useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import "jspdf-autotable"; 
import { useNavigate } from "react-router-dom";
import axiosInstance from '../axiosInstance';


function Dailyreport() {
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [formData, setFormData] = useState({
        from_name: '',
        from_address1: '',
        from_address2: '',
        from_address3: '',
        from_phone1: '',
        from_phone2: '',
        to_name: '',
        to_address1: '',
        to_address2: '',
        to_address3: '',
        to_phone1: '',
        to_phone2: '',
        ref_reg_no: '',
        ref_vehicle_type: '',
        ref_vehicle_color: '',
        ref_amount: '',
        bike_model: '',
        bike_make: '',
        bike_color: '',
        bike_chase_no: '',
        bike_engine_no: '',
        payment_type: '',
        cash_paid: '',
        balance: '',
        finance: '',
        emi_tenure: '',
        exchange_of: '',
        bank_name: '',
    });
    const [loading, setLoading] = useState(true);

    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY
    
    const [files, setFiles] = useState({
        aadhar_file: null,
        rc_file: null,
        photo_file: null,
    });

    const [errors, setErrors] = useState({
        aadhar_file: "",
        rc_file: "",
        photo_file: "",
    });

    const allowedFormats = ["application/pdf", "image/jpeg", "image/png"];

    // Handle form input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFileChange = (e) => {
        const { id, files } = e.target;
        const file = files[0];

        if (file) {
            const { type, size } = file;

            // Validate file format
            if (!allowedFormats.includes(type)) {
                setErrors((prev) => ({
                    ...prev,
                    [id]: "Invalid file type! Only PDF, JPG, and PNG allowed.",
                }));
                setFiles((prev) => ({ ...prev, [id]: null }));
                return;
            }

            // Validate file size
            if (
                (type === "application/pdf" && size > 100 * 1024) ||
                ((type === "image/jpeg" || type === "image/png") && size > 50 * 1024)
            ) {
                setErrors((prev) => ({
                    ...prev,
                    [id]: `File too large! Max size: ${type === "application/pdf" ? "100KB (PDF)" : "50KB (Image)"
                        }`,
                }));
                setFiles((prev) => ({ ...prev, [id]: null }));
                return;
            }

            // Clear errors and set file
            setErrors((prev) => ({ ...prev, [id]: "" }));
            setFiles((prev) => ({ ...prev, [id]: file }));
        }
    };

    const printBill = () => {
        const printContents = document.getElementById("download_section").innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;  // Replace body content with invoice
        window.print();  // Trigger the print dialog
        // Instead of restoring innerHTML manually, reload the page
        window.location.reload();
    };

    const savebilling = async (event) => {
        event.preventDefault();

        // Prevent multiple submissions
        if (isSaving || isSaved) return;

        setIsSaving(true); // Disable the button

        setLoading(true);
        setErrors({});

        try {
            // Get current date and time
            const currentDate = new Date();

            // Format date as YYYY-MM-DD
            const formattedDate = currentDate.toISOString().split('T')[0];

            // Format date and time as YYYY-MM-DD HH:MM:SS
            const formattedDateTime = currentDate.toISOString().replace('T', ' ').split('.')[0];

            // Get user ID from localStorage
            const created_by = localStorage.getItem('user_id');
            let billingId = "";
            let amt_in_words = "";

            // Add new fields to formData
            const updatedFormData = {
                ...formData,
                date: formattedDate,        // Stores only the date
                ref_time: formattedDateTime,     // Stores both date and time
                created_by: created_by,
            };
            console.log(updatedFormData)
            // Step 1: Save form data to billing API

            try {
                const formResponse = await axiosInstance.post('/billing/add', updatedFormData);
                console.log(formResponse.data.billing_id)
                billingId = formResponse.data.billing_id; // Get billing ID
                amt_in_words = formResponse.data.amt_in_words;

                const finaldata = {
                    ...updatedFormData,
                    bill_no: billingId,
                    ref_amountinwords: amt_in_words,      // Stores billingid to updatedfordata
                };
                setInvoiceData(finaldata);
            }
            catch (error) {
                console.error('Error saving data:', error);
                // Extract error message from API response
                let errorMessage = 'There was an issue in saving the record.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message; // Get error message from backend response
                }

                setInvoiceData([]);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: errorMessage,
                });
            }

            console.log(billingId)


            try {
                if (billingId) {
                    // Step 2: Save file data with billing_id
                    const formDataWithFile = new FormData();
                    formDataWithFile.append("billing_id", billingId); // Send billing ID
                    formDataWithFile.append("created_by", 1); // Send user ID (or get from session)
                    formDataWithFile.append("rc_file", files.rc_file);
                    formDataWithFile.append("aadhar_file", files.aadhar_file);
                    formDataWithFile.append("photo_file", files.photo_file);

                    const fileResponse = await axiosInstance.post("/file/upload", formDataWithFile,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                    setFileData(fileResponse.data);
                    // Wait for state to update before logging
                    setTimeout(() => {
                        console.log("Updated fileData:", fileData);
                    }, 500);
                    setIsSaved(true);
                    Swal.fire('Saved!', 'Form and file saved successfully', 'success');

                }

            }
            catch (error) {
                console.error('Error saving File:', error);
                // Extract error message from API response
                let errorMessage = 'There was an issue in saving the record.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message; // Get error message from backend response
                }

                setFileData([]);
                Swal.fire({
                    icon: 'error',
                    title: 'Error saving File!',
                    text: errorMessage,
                });
            }

            // Success
            //alert('Form and file saved successfully');
            //Swal.fire('Saved!', 'Form and file saved successfully', 'success');


        } catch (error) {
            setErrors((prev) => ({ ...prev, form: error.message }));
        } finally {
            setLoading(false);
        }
        setIsSaving(false); // Re-enable the button
    };

    const handleClear = () => {
        setInvoiceData({});
        setFileData({});
        setFiles([]);
        setErrors({});

        // Navigate without reload
        navigate("/dailyreport", { replace: true });
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Daily Report</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-primary">
                                <div class="card-header">
                                    <h3 class="card-title">Billing</h3>
                                </div>
                                <form onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}>
                                    <div class="card-body">
                                        <label for="from">From:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_name">Name</label>
                                                    <input type="text" class="form-control" value={formData.from_name} onChange={handleInputChange} name="from_name" placeholder="Enter Name" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_address1">Address 1</label>
                                                    <input type="text" class="form-control" value={formData.from_address1} onChange={handleInputChange} name="from_address1" placeholder="Enter Address" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_address2">Address 2</label>
                                                    <input type="text" class="form-control" value={formData.from_address2} onChange={handleInputChange} name="from_address2" placeholder="Enter Address 2" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_address3">Address 3</label>
                                                    <input type="text" class="form-control" value={formData.from_address3} onChange={handleInputChange} name="from_address3" placeholder="Enter Address 3" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_phone1">Phone Number 1</label>
                                                    <input type="text" class="form-control" value={formData.from_phone1} onChange={handleInputChange} name="from_phone1" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="from_phone2">Phone Number 2</label>
                                                    <input type="text" class="form-control" value={formData.from_phone2} onChange={handleInputChange} name="from_phone2" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                        </div>

                                        <label for="to">To:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_name">Name</label>
                                                    <input type="text" class="form-control" value={formData.to_name} onChange={handleInputChange} name="to_name" placeholder="Enter Name" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_address1">Address 1</label>
                                                    <input type="text" class="form-control" value={formData.to_address1} onChange={handleInputChange} name="to_address1" placeholder="Enter Address" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_address2">Address 2</label>
                                                    <input type="text" class="form-control" value={formData.to_address2} onChange={handleInputChange} name="to_address2" placeholder="Enter Address 2" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_address3">Address 3</label>
                                                    <input type="text" class="form-control" value={formData.to_address3} onChange={handleInputChange} name="to_address3" placeholder="Enter Address 3" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_phone1">Phone Number 1</label>
                                                    <input type="text" class="form-control" value={formData.to_phone1} onChange={handleInputChange} name="to_phone1" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="to_phone2">Phone Number 2</label>
                                                    <input type="text" class="form-control" value={formData.to_phone2} onChange={handleInputChange} name="to_phone2" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Ref:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_reg_no">Registration NO</label>
                                                    <input type="text" class="form-control" value={formData.ref_reg_no} onChange={handleInputChange} name="ref_reg_no" placeholder="Enter Registration No" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_vehicle_type">Vehicle Type</label>
                                                    <input type="text" class="form-control" value={formData.ref_vehicle_type} onChange={handleInputChange} name="ref_vehicle_type" placeholder="Enter Vehicle Type" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_vehicle_color">Vehicle Color</label>
                                                    <input type="text" class="form-control" value={formData.ref_vehicle_color} onChange={handleInputChange} name="ref_vehicle_color" placeholder="Enter Vehicle Color" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="ref_amount">Amount</label>
                                                    <input type="text" class="form-control" value={formData.ref_amount} onChange={handleInputChange} name="ref_amount" placeholder="Enter Amount" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Vehicle Details:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_model">Model</label>
                                                    <input type="text" class="form-control" value={formData.bike_model} onChange={handleInputChange} name="bike_model" placeholder="Enter Model" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_make">Make</label>
                                                    <input type="text" class="form-control" value={formData.bike_make} onChange={handleInputChange} name="bike_make" placeholder="Enter Make" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_color">Color</label>
                                                    <input type="text" class="form-control" value={formData.bike_color} onChange={handleInputChange} name="bike_color" placeholder="Enter Color" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_chase_no">Chase No</label>
                                                    <input type="text" class="form-control" value={formData.bike_chase_no} onChange={handleInputChange} name="bike_chase_no" placeholder="Enter Chase No" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bike_engine_no">Engine No</label>
                                                    <input type="text" class="form-control" value={formData.bike_engine_no} onChange={handleInputChange} name="bike_engine_no" placeholder="Enter Chase No" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Finance Details:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="payment_type">Payment Type</label>
                                                    <select className="form-control select2" style={{ width: "100%", borderColor: "black" }} name="payment_type" value={formData.payment_type} onChange={handleInputChange} >
                                                        <option value="" disabled>Select Payment Type</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Cheque">Cheque</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="cash_paid">Cash Paid</label>
                                                    <input type="text" class="form-control" value={formData.cash_paid} onChange={handleInputChange} name="cash_paid" placeholder="Enter Cash Paid" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="balance">Balance</label>
                                                    <input type="text" class="form-control" value={formData.balance} onChange={handleInputChange} name="balance" placeholder="Enter Balance" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="finance">Finance</label>
                                                    <input type="text" class="form-control" value={formData.finance} onChange={handleInputChange} name="finance" placeholder="Enter Finance" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="emi_tenure">EMI / Tenure</label>
                                                    <input type="text" class="form-control" value={formData.emi_tenure} onChange={handleInputChange} name="emi_tenure" placeholder="Enter EMI / Tenure" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="bank_name">Bank Name</label>
                                                    <input type="text" class="form-control" value={formData.bank_name} onChange={handleInputChange} name="bank_name" placeholder="Enter Bank Name" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="exchange_of">Exchange Of</label>
                                                    <input type="text" class="form-control" value={formData.exchange_of} onChange={handleInputChange} name="exchange_of" placeholder="Enter Exchange Of" />
                                                </div>
                                            </div>
                                        </div>

                                        {["aadhar_file", "rc_file", "photo_file"].map((field) => (
                                            <div key={field} className="form-group">
                                                <label htmlFor={field}>
                                                    {field.replace("_file", "").toUpperCase()}
                                                </label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id={field}
                                                            onChange={handleFileChange}
                                                            accept=".pdf,.jpg,.jpeg,.png"
                                                        />
                                                        <label className="custom-file-label">
                                                            {files[field] ? files[field].name : "Choose file"}
                                                        </label>
                                                    </div>
                                                </div>
                                                {errors[field] && <small className="text-danger">{errors[field]}</small>}
                                            </div>
                                        ))}
                                    </div>

                                    <div class="card-footer">
                                        <button type="submit" class="btn btn-primary" onClick={savebilling} disabled={isSaving || isSaved}>{isSaved ? 'Bill Saved' : isSaving ? 'Saving...' : 'Save Bill'}</button>
                                        {/* Print and Download Buttons */}
                                        {isSaved && (
                                            <div>
                                                <button type="button" className="btn btn-secondary mb-4 mr-2" onClick={printBill} style={{ marginTop: '10px' }}>
                                                    Print
                                                </button>
                                                <button type="button" className="btn btn-success mb-4" onClick={handleClear} style={{ marginTop: '10px' }}>
                                                    clear
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </section >

            {invoiceData && (
                <div id="download_section" style={{ display: "none" }}>
                    <div className="delivery-note-container">
                        <div className="delivery-note-header">
                            <img src="dist/img/sivam3.png" alt="Shivam Moto Banner" className="header-image" />
                        </div>

                        <div className="delivery-note-section">
                            {/* Left Section for DN No. and Date */}
                            <div className="delivery-note-left">
                                <p><strong>Bill No:</strong>{invoiceData.bill_no}</p>
                                <p><strong>Date:</strong>{invoiceData.date}</p>
                            </div>

                            <h3 className="delivery-note-title">DELIVERY NOTE</h3>


                            {/* Right Section for Image */}
                            <div className="delivery-note-image">
                                <div className="delivery-note-image-container">
                                    <img src={`https://apiemiride.socialpartners.in/api/file/uploads/${fileData?.photo || ''}`} alt="Buyer" className="fixed-image" />
                                </div>
                            </div>

                        </div>

                        <div className="delivery-note-info">
                            <div>
                                <h3 className="delivery-note-fromto">From:</h3>
                                <p>{invoiceData.from_name}</p>
                                <p>{invoiceData.from_address1}</p>
                                <p>{invoiceData.from_address2}</p>
                                <p>{invoiceData.from_address3}</p>
                                <p>
                                    <strong>Phone:</strong> {invoiceData.from_phone1}, {invoiceData.from_phone2}
                                </p>
                            </div>
                            <div>
                                <h3 className="delivery-note-fromto">To:</h3>
                                <p>{invoiceData.to_name}</p>
                                <p>{invoiceData.to_address1}</p>
                                <p>{invoiceData.to_address2}</p>
                                <p>{invoiceData.to_address3}</p>
                                <p>
                                    <strong>Phone:</strong> {invoiceData.to_phone1}, {invoiceData.to_phone2}
                                </p>
                            </div>
                        </div>

                        <div className="delivery-note-right-align">
                            <p><strong>Sir,</strong></p>
                            <div className="letter-content">
                                <p><strong>Ref:</strong> {invoiceData.ref_reg_no} / {invoiceData.ref_vehicle_type} {invoiceData.ref_vehicle_color}</p>
                                <p>
                                    I have this day purchased the above vehicle from you for the sum of Rs.<strong> {invoiceData.ref_amount}</strong> (Rupees in Words: <strong> {invoiceData.ref_amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                </p>
                                <p>
                                    The entire risk is being bome by me / us / from this time <strong>{invoiceData.ref_time}</strong>
                                </p>
                            </div>
                        </div>

                        <div className="delivery-note-row">
                            {/* Left: Vehicle Details */}
                            <div className="delivery-note-vehicle-details">
                                <h3 className="delivery-note-fromto">Vehicle Details</h3>
                                <p><strong>Model:</strong><span>{invoiceData.bike_model}</span></p>
                                <p><strong>Make:</strong><span>{invoiceData.bike_make}</span></p>
                                <p><strong>Color:</strong> <span>{invoiceData.bike_color}</span></p>
                                <p><strong>Chase No:</strong> <span>{invoiceData.bike_chase_no}</span></p>
                                <p><strong>Engine No:</strong> <span>{invoiceData.bike_engine_no}</span></p>
                            </div>

                            {/* Right: Payment Details */}
                            <div className="delivery-note-payment">
                                <h3 className="delivery-note-fromto">Payment Details</h3>
                                <p><strong>Payment Type:</strong><span> {invoiceData.payment_type}</span></p>
                                <p><strong>Cash Paid:</strong><span>{invoiceData.cash_paid}</span></p>
                                <p><strong>Balance:</strong><span>{invoiceData.balance}</span> </p>
                                <p><strong>Finance:</strong><span> {invoiceData.finance}</span></p>
                                <p><strong>EMI / Tenure:</strong><span>{invoiceData.emi_tenure}</span></p>
                                <p><strong>Exchange Of:</strong><span>{invoiceData.exchange_of}</span></p>
                                <p><strong>Bank Name:</strong> <span>{invoiceData.bank_name}</span></p>
                            </div>
                        </div>

                        <div className="delivery-note-tamil-text">
                            <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                            <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                            <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                            <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                        </div>

                        <div className="delivery-note-signatures">
                            <div>
                                <p>
                                    <strong>Signature of Seller</strong>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <strong>Signature of Buyer</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >

    )
}

export default Dailyreport